/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Modal } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import SpotifyIcon from 'mdi-react/SpotifyIcon'
import { getSfaEmail } from 'Redux/selectors/campaigns'

const ModalComponent = ({
  toggle,
  modal,
  setSpotifyConnectionForArtist,
  artistSpotifyId,
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const sfaEmail = useSelector(getSfaEmail)

  const link =
    'https://content-soundcamps.s3.eu-central-1.amazonaws.com/public/video.mp4'
  const textAreaRef = useRef()
  const [isCoppied, setCopied] = useState(false)

  const goToSpotify = () => {
    window.open('https://artists.spotify.com/', '_blank')
  }

  function copyToClipboard(e) {
    textAreaRef.current.select()
    document.execCommand('copy')
    e.target.focus()
    setCopied(true)
  }

  const handleSubmit = () => {
    dispatch(setSpotifyConnectionForArtist(artistSpotifyId))
    toggle()
  }

  return (
    <div>
      <Modal
        fade={false}
        className="modal-dialog--success modal-dialog--header"
        isOpen={modal}
        modalClassName="ltr-support"
        toggle={toggle}
      >
        <div className="modal__header">
          <h4
            className="text-modal  modal__title"
            style={{
              fontWeight: '600',
            }}
          >
            {t('campaignResultsPage.connectForArtists')}
          </h4>
          <button
            className="lnr lnr-cross modal__close-btn"
            type="button"
            onClick={toggle}
          />
        </div>
        <div className="spotifyForArtists__content">
          <p className="spotifyForArtists__text">
            <span>{t('campaignResultsPage.toSetUpConnection')}</span> &nbsp;
            <span>
              <b> {t('campaignResultsPage.ofTheArtistPromoted')}</b>
            </span>{' '}
            &nbsp;
            <span>{t('campaignResultsPage.usingTheEmail')}</span>&nbsp;
            <span>
              <a href={`mailto: ${sfaEmail}`}>{sfaEmail}</a>.
            </span>
          </p>
          <div className="spotifyForArtists__block">
            <div className="spotifyForArtists__left">
              <ol className="spotifyForArtists__list">
                <li>{t('campaignResultsPage.goToSpotifyForArtists')}</li>
                <li>{t('campaignResultsPage.clickThe')}</li>
                <li>{t('campaignResultsPage.fillInTheFields')}</li>
                <li>{t('campaignResultsPage.selectViewer')}</li>
                <li>{t('campaignResultsPage.sendInvite')}</li>
              </ol>
            </div>
            <div className="spotifyForArtists__right">
              <textarea
                ref={textAreaRef}
                className="spotifyForArtists__textarea"
                value={sfaEmail}
                readOnly
              >
                {sfaEmail}
              </textarea>
              <button
                className="spotifyForArtists__btn copy__btn"
                style={{ margin: '0 auto' }}
                type="button"
                onClick={copyToClipboard}
              >
                {t('campaignResultsPage.copyEmail')}
              </button>
              {isCoppied && (
                <div className="spotifyForArtists__copied">
                  Email is copied to clipboard!
                </div>
              )}
            </div>
          </div>

          <div className="spotifyForArtists__video">
            <video width="100%" controls>
              <source src={link} type="video/mp4" />
            </video>
          </div>

          <Button
            color="success"
            style={{ margin: '0 auto 20px', padding: '9px 23px' }}
            onClick={goToSpotify}
          >
            <SpotifyIcon />
            {t('campaignResultsPage.goToSpotify')}
          </Button>
          <br />
          <p className="spotifyForArtists__text">
            {t('campaignResultsPage.pleaseLetUsKnow')}
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Button
              className="btn-outline-success"
              style={{ padding: '9px 23px' }}
              onClick={handleSubmit}
            >
              {t('campaignResultsPage.done')}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ModalComponent
